import React, { useEffect, useState } from 'react';
import Header from './Header';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import API_URL from '../config';
import { supabase } from '../supabaseClient';

dayjs.locale('pt-br');

function RelatorioMobtefPage({ usuario, empresaSelecionada, handleVoltar, handleSair }) {
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState('hoje');
  const [periodo, setPeriodo] = useState({ ini: dayjs().format('YYYY-MM-DD'), fim: dayjs().format('YYYY-MM-DD') });
  const [pagina, setPagina] = useState(1);
  const PAGE_SIZE = 20;

  useEffect(() => {
    if (!empresaSelecionada) {
      console.log('Aguardando empresaSelecionada estar definida:', empresaSelecionada);
      return;
    }
    console.log('empresaSelecionada:', empresaSelecionada);
    console.log('Chaves:', Object.keys(empresaSelecionada || {}));
    // Fallback temporário para garantir interface para empresa 611
    if (!empresaSelecionada.interface && empresaSelecionada.id === 611) {
      empresaSelecionada.interface = '8';
      console.log('Fallback: interface setada manualmente para 8');
    }
    buscarDados();
    // eslint-disable-next-line
  }, [empresaSelecionada, periodo]);

  const buscarDados = async () => {
    setCarregando(true);
    setErro('');
    try {
      console.log('empresaSelecionada:', empresaSelecionada);
      console.log('periodo:', periodo);
      if (String(empresaSelecionada?.interface) === '8') {
        console.log('Buscando dados do Supabase para empresa_id:', empresaSelecionada.id);
        let { data, error } = await supabase
          .from('prod_tef')
          .select('*')
          .eq('empresa_id', empresaSelecionada.id)
          .gte('emissao', periodo.ini)
          .lte('emissao', periodo.fim);
        console.log('Resultado Supabase:', { data, error });
        if (error) {
          setErro('Erro ao buscar dados do Supabase: ' + error.message);
          setCarregando(false);
          return;
        }
        setDados(data || []);
        setPagina(1);
        setCarregando(false);
        return;
      }
      const url = `${API_URL}/tef/relatorio?empresa_id=${empresaSelecionada.id}&data_ini=${periodo.ini}&data_fim=${periodo.fim}`;
      console.log('Buscando dados do backend:', url);
      const resp = await fetch(url);
      if (!resp.ok) {
        const data = await resp.json();
        setErro(data.error + (data.details ? ` (${data.details})` : '') || 'Erro ao buscar dados');
        setCarregando(false);
        return;
      }
      const data = await resp.json();
      setDados(data);
      setPagina(1); // Sempre volta para a primeira página ao buscar
    } catch (e) {
      setErro('Erro ao buscar dados');
      console.error('Erro ao buscar dados:', e);
    }
    setCarregando(false);
  };

  // Resumo do período filtrado
  const resumoFiltro = () => {
    let total = 0, vendas = 0;
    dados.forEach(l => {
      total += Number(l.valor);
      vendas++;
    });
    return { total, vendas };
  };

  // Resumo por status
  const resumoPorStatus = () => {
    const map = {};
    dados.forEach(l => {
      const status = mapStatus(l.status);
      if (!map[status]) map[status] = { total: 0, vendas: 0 };
      map[status].total += Number(l.valor);
      map[status].vendas++;
    });
    return map;
  };

  // Resumo por tipo (apenas tipos com status=1, comparação como string)
  const resumoPorTipo = () => {
    const map = {};
    dados.forEach(l => {
      if (String(l.status) !== '1') return;
      const tipo = mapTipo(l.tipo);
      if (!map[tipo]) map[tipo] = { total: 0, vendas: 0 };
      map[tipo].total += Number(l.valor);
      map[tipo].vendas++;
    });
    return map;
  };

  // Resumo por bandeira (apenas status=1, comparação como string)
  const resumoPorBandeira = () => {
    const map = {};
    dados.forEach(l => {
      if (String(l.status) !== '1') return;
      const bandeira = l.bandeira || 'Sem Bandeira';
      if (!map[bandeira]) map[bandeira] = { total: 0, vendas: 0 };
      map[bandeira].total += Number(l.valor);
      map[bandeira].vendas++;
    });
    return map;
  };

  // Paginação
  const totalPaginas = Math.ceil(dados.length / PAGE_SIZE);
  const dadosPaginados = dados.slice((pagina - 1) * PAGE_SIZE, pagina * PAGE_SIZE);

  // Agrupar por data
  const agrupado = {};
  dadosPaginados.forEach(l => {
    const data = dayjs(l.emissao).format('YYYY-MM-DD');
    if (!agrupado[data]) agrupado[data] = [];
    agrupado[data].push(l);
  });
  // Ordenar datas decrescente
  const datas = Object.keys(agrupado).sort((a, b) => dayjs(b).unix() - dayjs(a).unix());
  // Ordenar cada grupo por id decrescente e, em caso de empate, por emissao decrescente
  datas.forEach(data => {
    agrupado[data].sort((a, b) => {
      if (b.id !== a.id) return b.id - a.id;
      return new Date(b.emissao) - new Date(a.emissao);
    });
  });

  // Função para mapear tipo
  const mapTipo = (tipo) => {
    const tipos = {
      1: 'Crédito à Vista',
      2: 'Crédito Parcelado',
      3: 'Crédito Parcelado Emissor',
      4: 'Débito',
      6: 'Pix',
      10: 'Vale Alimentação',
      11: 'Vale Refeição',
      12: 'Vale Presente',
      13: 'Vale Combustível',
      50: 'ConexãoPIX',
    };
    return tipos[tipo] || tipo;
  };

  // Função para mapear status
  const mapStatus = (status) => {
    const statusMap = {
      0: 'Aberto',
      1: 'Autorizado',
      2: 'Falha',
      3: 'Negado',
      4: 'Cancelado',
      5: 'Arquivado',
      6: 'Estornado',
      9: 'Em Processamento',
      51: 'Cancelamento Solicitado',
    };
    return statusMap[status] || status;
  };

  // Troca de filtro
  const handleFiltro = (tipo) => {
    setFiltro(tipo);
    setPagina(1);
    if (tipo === 'hoje') {
      setPeriodo({ ini: dayjs().format('YYYY-MM-DD'), fim: dayjs().format('YYYY-MM-DD') });
    } else if (tipo === '7d') {
      setPeriodo({ ini: dayjs().subtract(6, 'day').format('YYYY-MM-DD'), fim: dayjs().format('YYYY-MM-DD') });
    } else if (tipo === '30d') {
      setPeriodo({ ini: dayjs().subtract(29, 'day').format('YYYY-MM-DD'), fim: dayjs().format('YYYY-MM-DD') });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresaSelecionada} onVoltar={handleVoltar} onSair={handleSair} />
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-3xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-4">Relatório MobTEF</h2>
          {erro && <div className="text-red-600 mb-4">{erro}</div>}
          {!erro && (
            <>
              {/* Resumo geral + por status - tudo em um card */}
              <div className="w-full mb-4">
                <div className="bg-blue-50 rounded-lg p-4 flex flex-col items-center border">
                  <div className="overflow-x-auto w-full">
                    <table className="min-w-full text-sm text-center">
                      <thead>
                        <tr>
                          <th className="px-3 py-2 font-semibold text-gray-700">
                            {filtro === 'hoje' && 'Hoje'}
                            {filtro === '7d' && 'Últimos 7 Dias'}
                            {filtro === '30d' && 'Últimos 30 Dias'}
                          </th>
                          {Object.keys(resumoPorStatus()).map(status => (
                            <th key={status} className="px-3 py-2 font-semibold text-gray-700">{status}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="px-3 py-2 bg-blue-100 rounded-l-lg">
                            <div className="text-blue-700 font-bold text-lg">R$ {resumoFiltro().total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            <div className="text-xs text-gray-500">{resumoFiltro().vendas} vendas</div>
                          </td>
                          {Object.values(resumoPorStatus()).map((info, i) => (
                            <td key={i} className="px-3 py-2">
                              <div className="text-blue-700 font-bold">R$ {info.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                              <div className="text-xs text-gray-500">{info.vendas} vendas</div>
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* Resumo por tipo - card único tipo tabela */}
              <div className="w-full mb-4">
                <div className="bg-blue-50 rounded-lg p-4 flex flex-col items-center border">
                  <div className="overflow-x-auto w-full">
                    {Object.keys(resumoPorTipo()).length === 0 ? (
                      <div className="text-center text-gray-500 py-4">Nenhuma venda autorizada no período</div>
                    ) : (
                      <table className="min-w-full text-sm text-center">
                        <thead>
                          <tr>
                            {Object.keys(resumoPorTipo()).map(tipo => (
                              <th key={tipo} className="px-3 py-2 font-semibold text-gray-700">{tipo}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {Object.values(resumoPorTipo()).map((info, i) => (
                              <td key={i} className="px-3 py-2">
                                <div className="text-blue-700 font-bold">R$ {info.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                                <div className="text-xs text-gray-500">{info.vendas} vendas</div>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              {/* Resumo por bandeira - card único tipo tabela */}
              <div className="w-full mb-4">
                <div className="bg-blue-50 rounded-lg p-4 flex flex-col items-center border">
                  <div className="overflow-x-auto w-full">
                    {Object.keys(resumoPorBandeira()).length === 0 ? (
                      <div className="text-center text-gray-500 py-4">Nenhuma venda autorizada no período</div>
                    ) : (
                      <table className="min-w-full text-sm text-center">
                        <thead>
                          <tr>
                            {Object.keys(resumoPorBandeira()).map(bandeira => (
                              <th key={bandeira} className="px-3 py-2 font-semibold text-gray-700">{bandeira}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {Object.values(resumoPorBandeira()).map((info, i) => (
                              <td key={i} className="px-3 py-2">
                                <div className="text-blue-700 font-bold">R$ {info.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                                <div className="text-xs text-gray-500">{info.vendas} vendas</div>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              {/* Filtros */}
              <div className="flex gap-2 mb-4">
                <button className={`px-4 py-1 rounded ${filtro==='hoje'?'bg-blue-600 text-white':'bg-white border text-blue-600'}`} onClick={()=>handleFiltro('hoje')}>Hoje</button>
                <button className={`px-4 py-1 rounded ${filtro==='7d'?'bg-blue-600 text-white':'bg-white border text-blue-600'}`} onClick={()=>handleFiltro('7d')}>7 dias</button>
                <button className={`px-4 py-1 rounded ${filtro==='30d'?'bg-blue-600 text-white':'bg-white border text-blue-600'}`} onClick={()=>handleFiltro('30d')}>30 dias</button>
              </div>
              {/* Listagem */}
              <div className="w-full">
                {carregando ? <div className="text-center py-8">Carregando...</div> :
                  datas.length === 0 ? <div className="text-center py-8 text-gray-500">Nenhuma venda encontrada.</div> :
                  datas.map(data => (
                    <div key={data} className="mb-6">
                      <div className="bg-gray-100 px-3 py-1 rounded font-semibold text-gray-700 mb-2">{dayjs(data).locale('pt-br').format('DD [de] MMMM [de] YYYY')}</div>
                      {agrupado[data].map(l => (
                        <div key={l.id} className="flex items-center justify-between border-b py-2">
                          <div className="flex items-center gap-3">
                            <span className="text-xs font-mono text-gray-400">#{l.id}</span>
                            <span className="text-xs text-gray-500">{dayjs(l.emissao).format('HH:mm')}</span>
                            <span className="text-sm font-medium text-gray-700">{mapTipo(l.tipo)}</span>
                            <span className="text-xs font-bold text-blue-700">{l.bandeira}</span>
                          </div>
                          <div className="flex items-center gap-6">
                            <div className="text-base font-semibold text-gray-800">R$ {Number(l.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                            <div className="text-xs text-right">
                              <span className={l.status === 1 ? 'text-green-600 font-semibold' : 'text-red-600 font-semibold'}>{mapStatus(l.status)}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))
                }
              </div>
              {/* Paginação melhorada */}
              {totalPaginas > 1 && (
                <div className="flex justify-center items-center mt-6 mb-2 w-full">
                  {(() => {
                    const pages = [];
                    let start = Math.max(1, pagina - 3);
                    let end = Math.min(totalPaginas, pagina + 3);
                    if (pagina <= 4) {
                      start = 1;
                      end = Math.min(7, totalPaginas);
                    } else if (pagina > totalPaginas - 4) {
                      start = Math.max(1, totalPaginas - 6);
                      end = totalPaginas;
                    }
                    if (start > 1) pages.push(<span key="start-ellipsis" className="px-2">...</span>);
                    for (let i = start; i <= end; i++) {
                      pages.push(
                        <button
                          key={i}
                          className={`w-10 h-10 flex items-center justify-center rounded transition font-semibold border mx-0.5
                            ${pagina === i ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-200 hover:bg-blue-50'}`}
                          onClick={() => setPagina(i)}
                        >
                          {i}
                        </button>
                      );
                    }
                    if (end < totalPaginas) pages.push(<span key="end-ellipsis" className="px-2">...</span>);
                    return pages;
                  })()}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RelatorioMobtefPage; 